
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import styles from './styles.js';

const Logo = ({ flyoutOpen, handleFlyoutMenu, domain }) => {
    return (
        <div className={css(styles.logoContainer)}>
            <div>
                <a
                    href={`/${domain}`}
                    className={css(styles.logoContainerLink)}
                >
                    <div className={css(styles.content)}>
                        <div className={css(styles.logo)}>
                            <svg
                                className={css(styles.zipcubeIcon)}
                                viewBox="5 10 15 23"
                            >
                                <g>
                                    <g>
                                        <path
                                            d="M13.1,10.8l3.7,2.2l-3.7,2l-3.7,-2l3.7,-2.2Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M22.8,16.4l-3.7,-2.1l-3.7,2.1l3.6,2.1l0,6.9l-5.9,3.5l-6,-3.5l0,-6.9l-3.7,-2.1l0,11.1l9.7,5.6l9.7,-5.6l0,-11.1Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                    </g>
                                </g>
                            </svg>
                            <svg
                                className={css(styles.zipcubeLogoSvg)}
                                viewBox="70 0 5 44"
                            >
                                <g>
                                    <g>
                                        <path
                                            d="M31.4,17l10,0l0,1.6l-7.8,7.9l7.8,0l0,1.5l-10,0l0,-1.5l7.9,-8l-7.9,0l0,-1.5Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M44.4,15.3c-0.7,0 -1.3,-0.6 -1.3,-1.3c0,-0.7 0.6,-1.3 1.3,-1.3c0.7,0 1.3,0.6 1.3,1.3c0,0.7 -0.6,1.3 -1.3,1.3Zm-0.8,1.7l1.5,0l0,11l-1.5,0l0,-11Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M49.1,26.1l0,7.1l-1.5,0l0,-11c0,-3.1 2.4,-5.6 5.5,-5.6c3.1,0 5.5,2.5 5.5,5.6c0,3.2 -2.6,5.6 -5.5,5.6c-1.6,0.2 -3,-0.5 -4,-1.7Zm0,-3.7c0,2.3 1.8,4.1 4,4.1c2.2,0 4,-1.8 4,-4.1c0,-2.2 -1.8,-4.1 -4,-4.1c-2.2,0 -4,1.7 -4,4.1Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M68.2,19.5c-1.6,-1.6 -4.2,-1.6 -5.7,0c-1.6,1.6 -1.6,4.2 0,5.8c1.6,1.6 4.2,1.6 5.7,0l1,1c-2.2,2.2 -5.6,2.2 -7.8,0c-2.2,-2.2 -2.2,-5.7 0,-7.9c2.2,-2.2 5.7,-2.1 7.8,0l-1,1.1Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M81.6,28l-1.5,0l0,-1.6c-1,1.1 -2.4,1.7 -4,1.7c-3,0 -5.5,-2.4 -5.5,-5.6l0,-5.6l1.5,0l0,5.6c0,2.3 1.8,4.1 4,4.1c2.2,0 4,-1.8 4,-4.1l0,-5.6l1.5,0l0,11.1Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M94.6,22.5c0,3.1 -2.4,5.6 -5.5,5.6c-3.1,0 -5.5,-2.5 -5.5,-5.6l0,-11.4l1.5,0l0,7.4c1,-1.1 2.4,-1.7 4,-1.7c2.9,0.1 5.5,2.5 5.5,5.7Zm-1.5,-0.1c0,-2.3 -1.8,-4.1 -4,-4.1c-2.2,0 -4,1.8 -4,4.1c0,2.2 1.8,4.1 4,4.1c2.2,0 4,-1.9 4,-4.1Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M99,25.8c0.6,0.4 1.4,0.7 2.3,0.7c2.2,0 4.1,-1.8 4.1,-4.1l1.5,0c0,3.1 -2.4,5.6 -5.5,5.6c-3.1,0 -5.5,-2.5 -5.5,-5.6c0,-3.1 2.4,-5.6 5.5,-5.6c1.8,0 3.4,0.9 4.4,2.2l-6.8,6.8Zm-1.1,-1.2l5.6,-5.7c-0.6,-0.4 -1.4,-0.7 -2.3,-0.7c-2.2,0 -4,1.8 -4,4.1c0,1 0.3,1.7 0.7,2.3Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div className={css(styles.menuIndicator)}>
                            <div
                                className={css(styles.iconWrapper)}
                                style={{ transform: 'rotate(0deg)' }}
                            >
                                <svg
                                    viewBox="0 0 18 18"
                                    role="presentation"
                                    aria-hidden="true"
                                    focusable="false"
                                    style={{
                                        display: 'block',
                                        fill: 'currentcolor',
                                        height: '1em',
                                        width: '1em'
                                    }}
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </a>
                <button
                    aria-label="Main navigation menu"
                    aria-haspopup="true"
                    className={css(styles.buttonContainer)}
                    onClick={handleFlyoutMenu}
                >
                    <div className={css(styles.content)}>
                        <div className={css(styles.logo)}>
                            <svg
                                className={css(styles.zipcubeLogoSmallSvg)}
                                viewBox="8 7 10 30"
                            >
                                <g>
                                    <g>
                                        <path
                                            d="M13.1,10.8l3.7,2.2l-3.7,2l-3.7,-2l3.7,-2.2Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                        <path
                                            d="M22.8,16.4l-3.7,-2.1l-3.7,2.1l3.6,2.1l0,6.9l-5.9,3.5l-6,-3.5l0,-6.9l-3.7,-2.1l0,11.1l9.7,5.6l9.7,-5.6l0,-11.1Z"
                                            style={{
                                                fill: '#00b9ff',
                                                fillRule: 'nonzero'
                                            }}
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div className={css(styles.menuIndicator)}>
                            <div
                                className={css(styles.iconWrapper)}
                                style={
                                    flyoutOpen ?
                                        { transform: 'rotate(180deg)' } :
                                        { transform: 'rotate(0deg)' }
                                }
                            >
                                <svg
                                    viewBox="0 0 18 18"
                                    role="presentation"
                                    aria-hidden="true"
                                    focusable="false"
                                    style={{
                                        display: 'block',
                                        fill: 'currentcolor',
                                        height: '1em',
                                        width: '1em'
                                    }}
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </button>
            </div>
        </div>
    );
};

Logo.propTypes = {
    domain: PropTypes.string.isRequired,
    flyoutOpen: PropTypes.bool.isRequired,
    handleFlyoutMenu: PropTypes.func.isRequired
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Header/Logo/Logo.jsx